import React, {useState} from 'react';
import './ClubPresentation.css';
import {getLongNameChamp} from '../variables';
import {CapsPresentationPROAM, CapsPresentationPROBM, CapsPresentationPROAD, CapsPresentationPROBD} from '../capsules'
import { useLocation } from 'react-router-dom';
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

function ClubPresentation({championnat}) {

    // On récupère le nom du championnat complet
    // avec le diminutif
    const longName = getLongNameChamp(championnat)

    const getCorrectPresentation = () => {
        switch (championnat) {
            case 'proam':
                return CapsPresentationPROAM()
                break;
            case 'probm':
                return CapsPresentationPROBM()
                break;
            case 'proad':
                return CapsPresentationPROAD()
                break;
            case 'probd':
                return CapsPresentationPROBD()
                break;
        }
    }

    return ( 
        <div className="club_presentation_page">
            <div className={"top_banniere " + championnat}>
                {
                    championnat == 'proam' &&
                        <span>
                            <img src={logoProAM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'proad' &&
                        <span>
                            <img src={logoProAD} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probm' &&
                        <span>
                            <img src={logoProBM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probd' &&
                        <span>
                            <img src={logoProBD} alt="Logo pro" className="logo_p" />
                        </span>
                } 
                <span className="top_banniere_title">
                    Présentation
                </span>
            </div>

            <div className="club_presentation_container">
                <h1>{longName.toUpperCase()}</h1>
                {getCorrectPresentation()}
            </div>
        </div>
    );
}

export default ClubPresentation;